<template>
  <div>

    <v-dialog
    v-model="error"
    width="500"
    >

      <v-card>
        <v-card-title
          class="headline red accent-3"
          primary-title
        >
          Warning Message
        </v-card-title>

        <v-card-text>
          {{errorMsg}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red accent-3"
            flat
            @click="setErrorZero"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-toolbar flat color="white">
      <v-toolbar-title></v-toolbar-title>
        <!-- <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider> -->
       <v-spacer></v-spacer>
       <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <!-- view page start here -->
      <v-dialog v-model="dialog">
        <template>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-container fluid>
                <v-card>
                  <v-card-title class="indigo white--text">
                    <div class="headline">Response Details</div>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">Task Id</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">{{editedItem.id}}</v-subheader>
                    </v-flex>
                    </v-layout>

                    <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">Project Id</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">{{editedItem.project_id}}</v-subheader>
                    </v-flex>
                    </v-layout>

                    <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">Dasher Name</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">{{editedItem.name}}</v-subheader>
                    </v-flex>
                    </v-layout>

                    <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">Task Starting Time</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">{{editedItem.started_at}}</v-subheader>
                    </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">Task Completed Time</v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">{{editedItem.completed_at}}</v-subheader>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">Task Rejected At</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">{{editedItem.rejected_at}}</v-subheader>
                    </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">Task Rejected By</v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">{{editedItem.rejected_by}}</v-subheader>
                      </v-flex>
                    </v-layout>

                  </v-card-text>  
                </v-card>

                <v-layout row>
                  <v-flex xs12>
                    <v-card>
                      <v-card-title class="indigo white--text">
                        <div class="headline">Question & Answer</div>
                      </v-card-title>
                      <v-card-text>
                        <div 
                          v-if="editedItem.project_type_id==2"
                          ><b>Task Accepted Location</b><br>
                          <span><b>Latitude:</b> {{editedItem.latitude}}</span><br>
                          <span><b>Longitude:</b> {{editedItem.longitude}}</span>
                        </div>
                        <div
                        v-for="(ques,i) in indexData.questions"
                        :key="i" 
                        >
                          <div>
                            <span>{{i+1}}.</span>
                            <span v-if="editedItem.project_language ==1 || editedItem.project_language ==3">
                              <span class="font-weight-bold">Question Title English:</span> &nbsp;&nbsp;&nbsp;{{ ques.question }}
                              <span class="red--text headline" v-if="ques.required_optional == 1">
                                *
                              </span>
                            </span>
                            <br />
                            <span class="font-weight-bold" v-if="editedItem.project_language ==2 || editedItem.project_language ==3">
                            &nbsp;&nbsp;&nbsp; <span class="font-weight-bold">Question Title Bangla:</span> &nbsp;&nbsp;&nbsp;{{ ques.question_bangla }} <br />
                              <span class="red--text headline" v-if="ques.required_optional == 1">
                                *
                              </span>
                            </span> 
                            <br>
                            <span><b>Question Type:</b> {{ ques.ui_category }} </span>
                          </div>
                          <!-- for image type -->
                          <span class="font-weight-bold">Answer:</span>
                          <div v-if="ques.ui_category_id==9">
                            <div v-if="ques.multiple_answer=='1'">
                             <MultipleResponseView :multipleData='editedItem[getQuestionVariable(ques.question_sequence)]'></MultipleResponseView>
                            </div>
                            <div v-else>
                             <v-img 
                              height="150" 
                              width="200" 
                              :src="indexData.res_image + editedItem[getQuestionVariable(ques.question_sequence)]"
                              ></v-img>
                              <a :href="indexData.res_image + editedItem[getQuestionVariable(ques.question_sequence)]" target="_blank">download</a>
                            </div>
                          </div>
                          <!-- for audio type -->
                          <div v-else-if="ques.ui_category_id==10">
                            <div v-if="ques.multiple_answer=='1'">
                             <MultipleResponseView :multipleData='editedItem[getQuestionVariable(ques.question_sequence)]'></MultipleResponseView>
                            </div>
                            <div v-else>
                             <a :href="indexData.res_audio + editedItem[getQuestionVariable(ques.question_sequence)]" target="_blank">download</a>
                            </div>
                          </div>
                          <!-- for video type -->
                          <div v-else-if="ques.ui_category_id==11">
                            
                            <div v-if="ques.multiple_answer=='1'">
                             <MultipleResponseView :multipleData='editedItem[getQuestionVariable(ques.question_sequence)]'></MultipleResponseView>
                            </div>
                            <div v-else>
                             <a :href="indexData.res_video + editedItem[getQuestionVariable(ques.question_sequence)]" target="_blank">download</a>
                            </div>
                          </div>
                          <!-- for contactInfo type -->
                          <div v-else-if="ques.ui_category_id==15">
                            <div>
                             <ContactInfoResponse :contactForm='editedItem[getQuestionVariable(ques.question_sequence)]' />
                            </div>
                          </div>
                          <!-- for multiple choice image -->
                          <div v-else-if="ques.ui_category_id==14">
                            <div>
                              <v-img 
                              height="150" 
                              width="200" 
                              :src="indexData.mul_choice_image + editedItem[getQuestionVariable(ques.question_sequence)]"
                              ></v-img>
                              <a :href="indexData.mul_choice_image + editedItem[getQuestionVariable(ques.question_sequence)]" target="_blank">download</a>
                            </div>
                          </div>
                          <!-- for open ended type -->
                          <div v-else>
                           <div v-if="ques.multiple_answer=='1'">
                              <MultipleResponseView :multipleData='editedItem[getQuestionVariable(ques.question_sequence)]'></MultipleResponseView>
                            </div>
                            <div v-else>
                              {{editedItem[getQuestionVariable(ques.question_sequence)]}}
                            </div>
                          </div>
                          <br>
                        </div>

                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout> 
                
              </v-container>
            </v-flex>
          </v-layout>
        <!-- <v-divider inset></v-divider> -->
        <v-container fluid>
          <v-layout row>
            <div>
              <v-btn color="red" @click="close">Cancel</v-btn>
            </div>
          </v-layout>
        </v-container>
      </template>
    </v-dialog>
      <!-- view page end here -->
    </v-toolbar>
     <div v-if="alertMsg">
        <v-alert v-if="error == 0 && statusCode == 200" :value="true" type="success" transition="slide-y-reverse-transition">{{ errorMsg }}</v-alert>
        <v-alert v-if="error == 1 && statusCode == 204" :value="true" type="info" transition="slide-y-reverse-transition">{{ errorMsg }}</v-alert>
        <v-alert v-if="error == 1 && (statusCode == 403 || statusCode == 400)" :value="true" type="warning" transition="slide-y-reverse-transition">{{ errorMsg }}</v-alert>
        <v-alert v-if="error == 1 && statusCode == 500" :value="true" type="error" transition="slide-y-reverse-transition">{{ errorMsg }}</v-alert>
     </div>
     <div v-if="isLoaded">
     <div v-if="indexData.totalTasks < 1" class="text-xs-center">
       <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>

     </div>
      <v-data-table
        :headers="headers"
        :items="indexData.dataStatus4.data"
        :search="search"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        class="elevation-1"
      >
      <v-progress-linear color="blue" indeterminate></v-progress-linear>
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ props.header.text }}
              </span>
            </template>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
      
        <template v-if="indexData.totalTasks > 0" v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.project_id }}</td>
          <td>{{ props.item.dasher_id }}</td>
          <td>{{ props.item.started_at }}</td>
          <td>{{ props.item.completed_at }}</td>
          <td>{{ props.item.rejected_at }}</td>
          <td>{{ props.item.rejected_by }}</td>
          <td class="justify-center layout px-1">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon small class="mr-2" v-on="on" @click="checkItem(props.item)">
                      visibility
                  </v-icon>
                </template>
              <span>view</span>
            </v-tooltip>
          </td>
        </template>
        <template v-else v-slot:no-data>
          <v-alert :value="true" color="error" icon="warning">
            {{ errorMsg }}
          </v-alert>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
        <template v-slot:pageText>
          Rows {{ indexData.dataStatus4.from }} - {{ indexData.dataStatus4.to }} of {{ indexData.dataStatus4.total }}
        </template>
      </v-data-table>
      <template>
        <div class="text-xs-center">
          <v-pagination
            v-model="indexData.dataStatus4.current_page"
            :length="indexData.dataStatus4.last_page"
            @input="onPageChange"
          ></v-pagination>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import MultipleResponseView from './MultipleResponseView'
import ContactInfoResponse from './ContactInfoResponse'
import {mapGetters} from 'vuex'

  export default {
    components: {
      MultipleResponseView,
      ContactInfoResponse
    },
    data: () => ({
      dialog: false,
      alertMsg: false,
      // apiUrl: 'change-status',
      routePath: '/pending',
      sl: 1,
      headers: [
        { text: 'Task Id', align: 'left', value: 'id' },
        { text: 'Project Id', align: 'left', value: 'project_id' },
        { text: 'Task Submitted By', align: 'left', sortable: false, value: 'dasher_id' },
        { text: 'Task starting time', value: 'started_at' },
        { text: 'Task completion Time', value: 'completed_at' },
        { text: 'Task Rejected At', value: 'rejected_at' },
        { text: 'Task Rejected By', value: 'rejected_by' },
        { text: 'Actions', align: 'center', value: 'name', sortable: false }
      ],
      loading: false,
      search: '',
      pagination: {
        rowsPerPage: 10,
      },
      rowsPerPageItems: [10, 20, 50, 100, 200, 500],
      editedIndex:-1,
      editedItem: {
        
      },
      defaultItem: {
        
      }
    }),
    
    computed: {
      ...mapGetters(['isLoggedIn','indexData', 'error', 'statusCode', 'errorMsg']),
      isLoaded() {
      if (this.indexData.dataStatus4) {
        return true;
      } else {
        return false;
      }
    },
    },

    watch: {
      pagination() {
            this.paginationMethod()
      },
      dialog (val) {
        val || this.close()
      }
    },

    // created () {
    //   this.initialize()
    // },

    methods: {
       initialize () {
        //  this.paginationMethod()
        let projectId = localStorage.getItem('projectId');
        this.$store.dispatch('changeTaskStatus', ['task-status', 4, projectId, "", 1, 10])
       
        this.alertMsg = true
        setTimeout(() => {
          this.alertMsg = false
        }, 300)
      },

      getQuestionVariable(questionSequence){
        return "var"+questionSequence;
      },

       setErrorZero () {
        this.$store.dispatch('setErrorZero')
      },

      checkItem (item) {
        // console.log(item)
        if(this.indexData.dataStatus4){
        this.editedIndex = this.indexData.dataStatus4.data.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      onPageChange(){
        this.paginationMethod()
      },

      paginationMethod() {
        this.loading = true
        let tableName = window.localStorage.getItem('projectId');
        if(this.search){
          this.$store.dispatch('changeTaskStatus', ['task-status', 4, tableName, this.search, this.indexData.dataStatus4.current_page, this.pagination.rowsPerPage])
          this.loading = (this.indexData.dataStatus4.data) ? false : true
            this.alertMsg = true
            setTimeout(() => {
              this.alertMsg = false
            }, 300)
        }else{
          this.$store.dispatch('changeTaskStatus', ['task-status', 4, tableName, "", this.indexData.dataStatus4.current_page, this.pagination.rowsPerPage])
          this.loading = (! this.indexData.error) ? false : true
            this.alertMsg = true
            setTimeout(() => {
              this.alertMsg = false
            }, 300)
        }
      },
    }
  }
</script>
<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem

  .imageResize
    width: auto
    height: auto
</style>